<script lang="ts">
	export { classes as class };
	let classes = 'w-6 h-6';
</script>

<svg
	class={classes}
	width="24"
	height="24"
	viewBox="0 0 24 24"
	fill="none"
	xmlns="http://www.w3.org/2000/svg"
>
	<path
		fill-rule="evenodd"
		clip-rule="evenodd"
		d="m7.84 2.82 4.83-1.3a2 2 0 0 1 2.45 1.42l.27 1.01a39.1 39.1 0 0 1 4.64-.62.75.75 0 1 1 .1 1.5c-3.53.22-8.4 1.32-12.52 2.72h10.86a.5.5 0 0 1 .5.53l-.78 11.67a3 3 0 0 1-3 2.8H8.81a3 3 0 0 1-3-2.8L5.06 8.5c-.73.3-1.41.6-2.03.9a.75.75 0 0 1-.67-1.34A39.09 39.09 0 0 1 6.7 6.28l-.27-1a2 2 0 0 1 1.42-2.46Zm1.61 7.48c.42-.02.77.29.8.7l.5 7.8a.75.75 0 1 1-1.5.1l-.5-7.8a.75.75 0 0 1 .7-.8Zm5.1 0c.41.03.72.39.7.8l-.5 7.8a.75.75 0 1 1-1.5-.1l.5-7.8a.75.75 0 0 1 .8-.7Z"
		fill="currentColor"
	/>
</svg>
